import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BarLine from '../common/graphs/barLine';
import Graph from './evolutionGraph';
import CircularIndicator from '../common/indicators/circularIndicator';
import moment from 'moment';

const position = obj => {
  if (obj.value || obj.value > 0) {
    let total = 150 * obj.value;
    total /= obj.total;
    total += -67;
    return total;
  }
  return -67;
};

const fecha = (filter, fecha, formatDate) => {
  if (filter) {
    return moment(filter).format(formatDate);
  } else if (fecha.response) {
    return moment(fecha.response.maxDate.substring(0, 10)).format(formatDate);
  }
  return '';
};

const SummaryMain = props => (
  <section
    role="button"
    tabIndex={0}
    onClick={props.link}
    className={
      props.categorizationSeverity
        ? `main_summary new ${props.categorizationSeverity} `
        : 'main_summary new  OUTOFRISK'
    }
  >
    <div className="main_summary_graph main_summary_graph_right new">
      <div className="main_summary_graph__color new">
        <a className="normal flex" data-tags={false}>
          <span className="summary-circular-new">
            <CircularIndicator
              size={130}
              max={100}
              value={props.dailyFatigueEvolution.lastFatigueRiskPercentage}
              forceValue={100}
              fill
              id={'circle1'}
              valueFormat={{ type: 'NUMBER', format: '.0f', sufix: '%' }}
              graphColorRange={props.graphColorRange.fatigueRiskPercentage}
            />
            <section className="help">
              <section className="box-help">
                <i className="fas fa-question-circle" />
                <section className="box min">
                  {props.language.summary.fatigue.labelText}
                  <ul>
                    <li>
                      {' '}
                      <strong className="green">{props.language.summary.fatigue.underRisk}</strong>:
                      0%{' '}
                      {props.language.summary.fatigue.to}{' '}
                      {props.graphColorRange.fatigueRiskPercentage.outOfRisk[1]}%
                    </li>
                    <li>
                      {' '}
                      <strong className="yellow"> {props.language.summary.fatigue.midleRisk}</strong>:{' '}
                      {props.graphColorRange.fatigueRiskPercentage.middleRisk[0] + 1} %{' '}
                      {props.language.summary.fatigue.to}{' '}
                      {props.graphColorRange.fatigueRiskPercentage.middleRisk[1]}%
                    </li>
                    <li>
                      <strong className="red">{props.language.summary.fatigue.highRisk}</strong>:{' '}
                      {props.graphColorRange.fatigueRiskPercentage.higherRisk[0] + 1} %{' '}
                      {props.language.summary.fatigue.to} 100%
                    </li>
                  </ul>
                </section>
              </section>
            </section>
            <h4>{props.language.summary.fatigue.driversAtRisk}</h4>
            <h5>{fecha(props.filters.date.fechaEndFinal, props.date, props.language.account.date.format)}</h5>
          </span>
          {props.fatigueDistribution && (
            <span className="summary-circular-bar-new">
              <BarLine
                distribution={props.fatigueDistribution}
                language={props.title.summary.graphTooltip}
              />
              <h4>{props.language.summary.fatigue.driversAtRisk}</h4>
              <section className="help">
                <section className="box-help">
                  <i className="fas fa-question-circle" />
                  <section className="box">{props.language.summary.fatigue.distributionIndex}</section>
                </section>
              </section>
            </span>
          )}
        </a>
      </div>
    </div>
    <div className="main_summary_graph new">
      <div className="main_summary_graph__color new">
        <a data-tags={false}>
          {props.dailyFatigueEvolution.fatigueRiskPercentageEvolutions.length > 0 && (
            <Graph
              language={props.language}
              graphColorRange={props.graphColorRange}
              data={props.dailyFatigueEvolution.fatigueRiskPercentageEvolutions}
              id="test1"
            />
          )}
          <div
            className="main_summary_num new"
            style={{
              bottom: position({
                total: 100,
                value: props.dailyFatigueEvolution.lastFatigueRiskPercentage
              })
            }}
          >
            <h4 className={props.categorizationSeverity}>
              {props.dailyFatigueEvolution.lastFatigueRiskPercentage
                ? Math.round(props.dailyFatigueEvolution.lastFatigueRiskPercentage)
                : '0'}{' '}
              %
            </h4>
          </div>
        </a>
      </div>
    </div>
  </section>
);

export default SummaryMain;



// WEBPACK FOOTER //
// ./source/client/components/summary_fatigue/summaryMain.jsx